var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 83,
    viewBox: "0 0 60 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A303A",
    fillRule: "evenodd",
    d: "M60 75.3l-3.6-9L44.8 62l9.6-.8-2.1-5L35.5 52 50 50l-4.3-10.7-7.8-2.5 6.3-1.2v-.1l-9-4 6.7-1.8L30 0 19.7 25.7h8.8l-10.7 4.9 7.1 2.4-10.3 5.6-5.8 14.5 11.8-1.2L6 60.2l-1.3 3h7.7L2.3 69.6 0 75.3h25.7c.6 0 1 .3 1 .9l.9 6.8h4.6l.9-6.8c0-.5.4-1 1-1H60z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree1);
export default __webpack_public_path__ + "static/media/tree-1.1e41718d66228d6fc6fbf0aa48aff150.svg";
export { ForwardRef as ReactComponent };